import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Paper,
  useMediaQuery,
  Stack,
} from "@mui/material";
import { options } from "../constants";
import { Link, useLocation } from "react-router-dom";
import Logo from "../images/LOGO DEFINITIVO POLLOS TEOOO.png";

const Sidebar = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const location = useLocation();

  if (isMobile) {
    return null;
  }

  // Separar la opción de cerrar sesión del resto de opciones
  const navigationOptions = options.filter(
    (option) => option.route !== "/logout"
  );
  const logoutOption = options.find((option) => option.route === "/logout");

  return (
    <Box
      sx={{
        width: 240,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: 240,
          boxSizing: "border-box",
        },
      }}
    >
      <Paper
        elevation={1}
        sx={{
          p: 2,
          bgcolor: "background.paper",
          height: "calc(100vh - 32px)",
          borderRight: "1px solid #e0e0e0",
          borderRadius: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ overflow: "auto" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <img
              src={Logo}
              alt="Logo"
              style={{
                width: "100%",
                height: "auto",
                scale: "0.9",
                margin: "0px",
              }}
            />
          </Box>
          <Divider />
          <List>
            {navigationOptions.map((option, index) => (
              <ListItem
                button
                key={index}
                component={Link}
                to={option.route}
                sx={{
                  borderBottom:
                    location.pathname === option.route
                      ? "2px solid #fcd528"
                      : "none",

                  "&:hover": {
                    bgcolor: "#ebebeb",
                    borderBottom:
                      location.pathname === option.route
                        ? "2px solid #ecb806"
                        : "none",
                  },
                }}
              >
                <ListItemIcon>{option.icon}</ListItemIcon>
                <ListItemText primary={option.title} />
              </ListItem>
            ))}
          </List>
        </Box>

        <Box sx={{ flexGrow: 1 }} />
        <Stack sx={{ mb: 0, alignItems: "center" }}>
          <Link
            to="/about"
            style={{
              textDecoration: "none",
              color: "#000",
              display: "flex",
              alignItems: "center",
              padding: "10px 16px",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                display: "flex",
                alignItems: "center",
                color: "#525252",
                position: "relative",
                paddingBottom: "4px",
                transition: "all 0.3s ease",
                "&:after": {
                  content: '""',
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  height: "2px",
                  backgroundColor: "#fcd528",
                  transform: "scaleX(0)",
                  transformOrigin: "bottom right",
                  transition: "transform 0.3s ease",
                },
                "&:hover": {
                  color: "#000",
                  "&:after": {
                    transform: "scaleX(1)",
                    transformOrigin: "bottom left",
                  },
                },
              }}
            >
              Acerca del proyecto
            </Typography>
          </Link>
        </Stack>
        {logoutOption && (
          <>
            <Divider sx={{ my: 2 }} />
            <ListItem
              button
              component={Link}
              to={logoutOption.route}
              sx={{
                borderRadius: "4px",
                "&:hover": {
                  bgcolor: "#ffeeee",
                },
                mb: 1,
              }}
            >
              <ListItemIcon sx={{ color: "error.main" }}>
                {logoutOption.icon}
              </ListItemIcon>
              <ListItemText
                primary={logoutOption.title}
                primaryTypographyProps={{
                  color: "error.main",
                  fontWeight: "medium",
                }}
              />
            </ListItem>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default Sidebar;
